import React from "react";
import Chip from "@mui/material/Chip";

const stepContainerStyle = {
  padding: "16px",
  borderRadius: "8px",
  backgroundColor: "#fafafa",
  marginBottom: "16px",
  border: "1px solid #eee",
};

const stepItemStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  padding: "10px 0",
  borderBottom: "1px solid #eee",
};

const dotStyle = (status) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  marginTop: "4px",
  flexShrink: 0,
  backgroundColor:
    status === "SENT" ? "#2e7d32" :
    status === "SCHEDULED" ? "#ed6c02" :
    status === "FAILED" ? "#d32f2f" :
    "#bdbdbd",
});

const STATUS_LABELS = {
  DRAFT: "Draft",
  SCHEDULED: "Scheduled",
  SENT: "Sent",
  FAILED: "Failed",
};

const OUTREACH_STATUS_COLORS = {
  GENERATING: "default",
  DRAFT: "default",
  ACTIVE: "warning",
  PAUSED: "default",
  COMPLETED: "success",
  REPLIED: "success",
};

const OutreachTimeline = ({ outreach }) => {
  if (!outreach) return null;

  return (
    <div style={stepContainerStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <h4 style={{ margin: 0 }}>Outreach Timeline</h4>
        <Chip label={outreach.status} size="small" color={OUTREACH_STATUS_COLORS[outreach.status] || "default"} />
      </div>

      {(outreach.steps || []).map((step) => (
        <div key={step.stepNumber} style={stepItemStyle}>
          <div style={dotStyle(step.status)} />
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <strong style={{ fontSize: "14px" }}>
                {step.stepNumber === 1 ? "Initial Email" : `Follow-up ${step.stepNumber - 1}`}
              </strong>
              <Chip
                label={STATUS_LABELS[step.status] || step.status}
                size="small"
                color={
                  step.status === "SENT" ? "success" :
                  step.status === "FAILED" ? "error" :
                  step.status === "SCHEDULED" ? "warning" :
                  "default"
                }
                variant="outlined"
              />
            </div>
            {step.waitDays > 0 && (
              <p style={{ margin: "2px 0", fontSize: "12px", color: "#999" }}>
                +{step.waitDays} days after previous
              </p>
            )}
            {step.sentAt && (
              <p style={{ margin: "2px 0", fontSize: "12px", color: "#2e7d32" }}>
                Sent: {new Date(step.sentAt).toLocaleString()}
              </p>
            )}
            {step.scheduledAt && step.status === "SCHEDULED" && (
              <p style={{ margin: "2px 0", fontSize: "12px", color: "#ed6c02" }}>
                Scheduled: {new Date(step.scheduledAt).toLocaleString()}
              </p>
            )}
            {step.error && (
              <p style={{ margin: "2px 0", fontSize: "12px", color: "#d32f2f" }}>
                Error: {step.error}
              </p>
            )}
            {step.subject && (
              <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#333" }}>
                <em>{step.subject}</em>
              </p>
            )}
          </div>
        </div>
      ))}

      {outreach.status === "REPLIED" && (
        <div style={{ marginTop: "12px", padding: "8px", backgroundColor: "#e8f5e9", borderRadius: "4px", textAlign: "center" }}>
          <strong style={{ color: "#2e7d32" }}>Reply received — sequence stopped</strong>
        </div>
      )}
    </div>
  );
};

export default OutreachTimeline;
